import moment from "moment";

export default {
    dataHoraInicio : moment(),
    dataHoraFim : moment(),
}